import React, { useState } from 'react';
import AnnouncementModal from './AnnouncementModal';
import AlertModal from './AlertModal';
import UpdateModal from './UpdateModal';
import MaintenanceModal from './MaintenanceModal';

const NotificationModalsHost: React.FC = () => {
  const [triggerNotificationRefresh, setTriggerNotificationRefresh] = useState(0);

  const isLoggedIn = !!localStorage.getItem('authToken');

  if (!isLoggedIn) return null;

  const handleNotificationRead = () => {
    setTriggerNotificationRefresh(prev => prev + 1);
  };

  return (
    <>
      <AnnouncementModal
        key={`announcement-${triggerNotificationRefresh}`}
        onNotificationRead={handleNotificationRead}
      />
      <AlertModal
        key={`alert-${triggerNotificationRefresh}`}
        onNotificationRead={handleNotificationRead}
      />
      <UpdateModal
        key={`update-${triggerNotificationRefresh}`}
        onNotificationRead={handleNotificationRead}
      />
      <MaintenanceModal
        key={`maintenance-${triggerNotificationRefresh}`}
        onNotificationRead={handleNotificationRead}
      />
    </>
  );
};

export default NotificationModalsHost;
